import { ChatMessages } from './chat-messages'

export default ChatMessages
